import { Icon20LockOutline } from '@vkontakte/icons';
import emptyVigboFinishedBottom from 'img/empty-state/empty_vigbo_finished_bottom.png';
import emptyVigboFinishedTop from 'img/empty-state/empty_vigbo_finished_top.png';
import React from 'react';
import { Button } from 'reactApp/ui/Button/Button';

import styles from './EmptyFinishedVigbo.css';

export interface EmptyFinishedVigboProps {
    onClick?: () => void;
}

export function EmptyFinishedVigbo({ onClick }: EmptyFinishedVigboProps) {
    return (
        <div className={styles.root}>
            <div className={styles.lockIcon}>
                <Icon20LockOutline />
            </div>
            <img className={styles.topImage} src={emptyVigboFinishedTop} alt="Vigbo picture" />
            <div className={styles.content}>
                <div className={styles.text}>
                    <div className={styles.header}>Тут будут галереи Vigbo</div>
                    <div className={styles.description}>Подключите совместную подписку Mail Space, чтобы получить доступ к разделу</div>
                </div>
                <Button className={styles.button} onClick={onClick} theme="vk" primary>
                    Подключить
                </Button>
            </div>
            <img className={styles.bottomImage} src={emptyVigboFinishedBottom} alt="Albums picture" />
        </div>
    );
}
